import {EventEmitter, Injectable} from '@angular/core';
import {CommerceNavigationEventEmitter} from './commerce-event-emitter';
import {
  AddOnErrorEvent,
  AuthenticateEvent,
  CartChangeEvent,
  ContinueEvent,
  NavigationEvent,
} from './event.interface';

@Injectable({providedIn: 'root'})
export class CommerceEventEmitterService implements CommerceNavigationEventEmitter {
  authenticate?: EventEmitter<AuthenticateEvent>;
  cartLoad?: EventEmitter<CartChangeEvent>;
  cartUpdate?: EventEmitter<CartChangeEvent>;
  addOnError?: EventEmitter<AddOnErrorEvent>;
  continue?: EventEmitter<ContinueEvent>;
  navigation?: EventEmitter<NavigationEvent>;

  bind(component: CommerceNavigationEventEmitter): void {
    this.cartLoad = component.cartLoad;
    this.cartUpdate = component.cartUpdate;
    this.addOnError = component.addOnError;
    this.authenticate = component.authenticate;
    this.continue = component.continue;
    this.navigation = component.navigation;
  }
}
